function importAll(r) {
    return r.keys().map(r);
  }
  
  const India_L = importAll(require.context('../assets/photos/India_L', false, /\.(png|jpe?g|svg)$/));
    
  export default India_L;